import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allTool }) => {
  if (!allTool) return state;
  return state.merge({ allTool });
};

const setToolsData = (state, { toolsData }) => {
  if (!toolsData) return state;
  return state.merge({ toolsData });
};

const setToolById = (state, { tool }) => {
  if (!tool) return state;
  return state.merge({ tool });
};

//Tools Data Export set
const setToolExportData = (state, { toolExportData }) => {
  if (!toolExportData) return state;
  return state.merge({ toolExportData });
};
// Tool Data Export Loader
const setToolExportLoader = (state, { toolExportLoader }) => {
  return state.merge({ toolExportLoader });
};

const setAllToolsDataLoader = (state, { allToolsDataLoader }) => {
  return state.merge({ allToolsDataLoader });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setToolByFactoryId = (state, { getToolDataByFactoryId }) => {
  if (!getToolDataByFactoryId) return state;
  return state.merge({ getToolDataByFactoryId });
};

const setToolDeletable = (state, { toolDeletable }) => {
  return state.merge({ toolDeletable });
};

const setImportExcelToolFile = (state, { importToolFile }) => {
  return state.merge({ importToolFile });
};

const setImportExcelToolFileLoader = (state, { importExcelFileLoader }) => {
  return state.merge({ importExcelFileLoader });
};

const setToolDeletableLoader = (state, { toolDeletableLoader }) => {
  return state.merge({ toolDeletableLoader });
};
// ------------------- reducer function to download tool data by factory name
const setToolExportByFactoryLoader = (state, { toolExportByFactoryLoader }) => {
  return state.merge({ toolExportByFactoryLoader });
};
const setToolExportByFactoryData = (state, { toolExportByFactoryNameData }) => {
  if (!toolExportByFactoryNameData) return state;
  return state.merge({ toolExportByFactoryNameData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_TOOL_EXPORT_BY_FACTORY_LOADER,
    actionFunction: setToolExportByFactoryLoader,
  },
  {
    actionType: ActionTypes.SET_TOOL_EXPORT_BY_FACTORY,
    actionFunction: setToolExportByFactoryData,
  },
  {
    actionType: ActionTypes.EXPORT_TOOL_DATA_LOADER,
    actionFunction: setToolExportLoader,
  },
  {
    actionType: ActionTypes.SET_EXPORT_TOOL_DATA,
    actionFunction: setToolExportData,
  },
  {
    actionType: ActionTypes.SET_TOOLS_DATA,
    actionFunction: setToolsData,
  },
  {
    actionType: ActionTypes.SET_TOOL_BY_ID,
    actionFunction: setToolById,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_TOOLS_BY_FACTORYID,
    actionFunction: setToolByFactoryId,
  },
  {
    actionType: ActionTypes.SET_TOOL_DELETABLE,
    actionFunction: setToolDeletable,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_TOOL_FILE_LOADER_STATUS,
    actionFunction: setImportExcelToolFileLoader,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_TOOL_FILE,
    actionFunction: setImportExcelToolFile,
  },
  {
    actionType: ActionTypes.SET_TOOL_DELETABLE_LOADER_STATUS,
    actionFunction: setToolDeletableLoader,
  },
  {
    actionType: ActionTypes.FETCH_ALL_TOOL_DATA_LOADER,
    actionFunction: setAllToolsDataLoader,
  },
];
